import React, { useState, useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FiFilter } from "react-icons/fi";
import { GoSearch } from "react-icons/go";

export default function CreateCampaign(props) {
  const {
    getSchoolCampaignListData = [],
    getSchoolCampaignListTotal = 0, // kept if needed elsewhere
    campaignFormData,
    setCampaignFormData,
    saveCampaign
  } = props;

  const [search, setSearch] = useState("");

  /* ------------------ Input Handlers ------------------ */
  const handleChange = (e) => {
    const { name, value } = e.target;
    let temp = {
      ...campaignFormData,
      [name]: value,
    };
    setCampaignFormData(temp);

  };

  const handleMessageChange = (value) => {
    let temp = {
      ...campaignFormData,
      message: value,
    };
    setCampaignFormData(temp);
  };

  /* ------------------ Checkbox Handler ------------------ */
  const toggleEmployee = (ele) => {
    const empIdStr = ele.employeeId?.toString();
    const stuIdStr = ele.studentId?.toString();

    const list = campaignFormData.list || [];

    const exists = list.some(
      (item) => item.employeeId === empIdStr
    );

    const updatedList = exists
      ? list.filter(item => item.employeeId !== empIdStr)
      : [...list, { employeeId: empIdStr, studentId: stuIdStr }];

    setCampaignFormData({
      ...campaignFormData,
      list: updatedList,
    });
  };



  /* ------------------ Search Filter ------------------ */
  const filteredEmployees = useMemo(() => {
    if (!search) return getSchoolCampaignListData;

    return getSchoolCampaignListData.filter((emp) =>
      [emp.title, emp.email, emp.mobile]
        .join(" ")
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  }, [search, getSchoolCampaignListData]);

  return (
    <main className="w-full bg-[#f9fafb] h-screen overflow-hidden">
      <div className="flex w-full h-full">

        {/* LEFT PANEL */}
        <section className="w-[45%] bg-gray-100 overflow-y-auto">
          <div className="p-6 bg-white h-full space-y-6">

            <h2 className="text-xl font-medium text-[#3D405B] border-b pb-4">
              Create Campaign (Step 1)
            </h2>

            {/* Campaign Name */}
            <div>
              <label className="font-medium text-gray-900">Campaign Name</label>
              <input
                type="text"
                name="title"
                value={campaignFormData?.title || ""}
                onChange={handleChange}
                placeholder="Campaign Name"
                className="w-full p-2 border rounded mt-1"
              />
            </div>

            {/* Subject */}
            <div>
              <label className="font-medium text-gray-900">Subject</label>
              <input
                type="text"
                name="subject"
                value={campaignFormData?.subject || ""}
                onChange={handleChange}
                placeholder="Subject"
                className="w-full p-2 border rounded mt-1"
              />
            </div>


            {/* Email Name */}
            <div>
              <label className="font-medium text-gray-900">Email Name</label>
              <input
                type="text"
                name="emailName"
                value={campaignFormData?.emailName || ""}
                onChange={handleChange}
                placeholder="Email Name"
                className="w-full p-2 border rounded mt-1"
              />
            </div>

            {/* Email Message */}
            <div>
              <label className="font-medium text-gray-900">Email Message</label>
              <ReactQuill
                theme="snow"
                value={campaignFormData?.message || ""}
                onChange={handleMessageChange}
                placeholder="Message"
              />
            </div>


            {/* Team Name */}
            <div>
              <label className="font-medium text-gray-900">Team Name</label>
              <input
                type="text"
                name="teamname"
                value={campaignFormData?.teamname || ""}
                onChange={handleChange}
                placeholder="Team Name"
                className="w-full p-2 border rounded mt-1"
              />
            </div>

            {/* Selected Employees Count */}
            <div>
              <label className="font-medium text-gray-900">
                No. of Selected Employees
              </label>
              <input
                type="text"
                value={campaignFormData?.list?.length || 0}
                readOnly
                className="w-full p-2 border rounded"
              />
            </div>


            {/* Publish */}
            <button onClick={() => saveCampaign()} className="bg-[#009EA7] text-white py-3 rounded w-full text-lg font-medium uppercase">
              Publish
            </button>

          </div>
        </section>

        {/* RIGHT PANEL */}
        <section className="w-full bg-[#f5f7fa] px-6 py-4 overflow-hidden">
          <h2 className="text-xl font-medium text-[#212121] mb-4">
            Employees List (Step 2)
          </h2>

          {/* Search & Filter */}
          <div className="flex justify-between mb-4">
            <div className="relative w-64">
              <GoSearch className="absolute top-3 left-2 text-gray-400" />
              <input
                type="text"
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="pl-8 p-2 border rounded w-full"
              />
            </div>

            <button className="flex items-center gap-2 border px-4 py-2 rounded">
              <FiFilter />
              Filter
              <span className="bg-[#009EA7] text-white w-6 h-6 flex items-center justify-center rounded-full text-sm">
                {filteredEmployees.length}
              </span>
            </button>
          </div>

          {/* Table */}
          <div className="bg-white rounded shadow overflow-auto max-h-[70vh]">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-100 text-left sticky top-0">
                <tr>
                  <th className="px-4 py-3 w-12"></th>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Email</th>
                  <th className="px-4 py-3">Mobile</th>
                </tr>
              </thead>
              <tbody>
                {filteredEmployees.length > 0 ? (
                  filteredEmployees.map((emp, index) => {
                    const isChecked =
                      campaignFormData?.list.map((inner) => (inner.employeeId))?.includes(emp.employeeId);

                    return (
                      <tr key={index} className="border-t">
                        {/* Checkbox */}
                        <td className="px-4 py-3">
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => toggleEmployee(emp)}
                            className="w-4 h-4 accent-[#009EA7]"
                          />
                        </td>

                        <td className="px-4 py-3 text-gray-700">
                          {emp.name}
                        </td>

                        <td className="px-4 py-3 text-gray-700">
                          {emp.email}
                        </td>

                        <td className="px-4 py-3 text-gray-700">
                          {emp.mobile}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-6 text-gray-400">
                      No employees found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>

      </div>
    </main>
  );
}
